<div [attr.data-test-id]="testId" [ngClass]="hintClasses">
  <nm-svg-icon *ngIf="icon" class="label-icon" [size]="16" [name]="icon"></nm-svg-icon>
  <span class="label-text" [title]="label">{{ label }}</span>
</div>
